import { render, staticRenderFns } from "./SubscriptionFlagFree.vue?vue&type=template&id=0dd281f7&scoped=true&"
import script from "./SubscriptionFlagFree.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFlagFree.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionFlagFree.vue?vue&type=style&index=0&id=0dd281f7&lang=scss&scoped=true&"
import style1 from "./SubscriptionFlagFree.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd281f7",
  null
  
)

export default component.exports